import {
  getAdminGigsterProfilesAiInterviewInvitesRetrieveQueryOptions,
  getAdminHighDemandSurchargesListQueryOptions,
  getAdminJobPostingsAppliedByProListQueryOptions,
  getAdminGigsterProfilesSickTimeRetrieveWithTransformQueryOptions,
  getAdminProBlockListQueryOptions,
  getCertificatesListQueryOptions,
  getSkillsListQueryOptions,
  type AdminJobPostingsAppliedByProListParams,
} from "@sidegigllc/api/client";
import { adminProQueryOptions } from "api/queries/admin";
import { marketsQueryOptions } from "api/queries/markets";
import { proOnboardingStepsQueryOptions } from "api/queries/pros";
import { notesQuery } from "domains/admin/containers/ProNotesTable/queries";
import { suspensionsQuery } from "domains/admin/containers/ProSuspensions/queries";
import { queries as proProfileQueries } from "domains/pros/views/ProProfile/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { proId: number };

export const onboardingStepsQuery = ({ proId }: QueriesInput) => proOnboardingStepsQueryOptions(proId);

export const aiInterviewInviteQuery = ({ proId }: QueriesInput) =>
  getAdminGigsterProfilesAiInterviewInvitesRetrieveQueryOptions(proId);

export const certificatesQuery = () =>
  getCertificatesListQueryOptions({ page_size: 100 }, { query: { staleTime: Number.POSITIVE_INFINITY } });

export const skillsQuery = () => getSkillsListQueryOptions({ query: "ordered_by_popularity" });

export const blocksQuery = ({ proId }: QueriesInput) =>
  getAdminProBlockListQueryOptions({ pro_id: proId }, { query: { enabled: !!proId } });

export const highDemandQuery = ({ proId }: QueriesInput) =>
  getAdminHighDemandSurchargesListQueryOptions({ gigster_id: proId }, { query: { enabled: !!proId } });

export const sickTimeQuery = ({ proId }: QueriesInput) =>
  getAdminGigsterProfilesSickTimeRetrieveWithTransformQueryOptions(proId);

export const jobApplicationsQuery = ({
  proId,
  search,
}: QueriesInput & { search: AdminJobPostingsAppliedByProListParams }) =>
  getAdminJobPostingsAppliedByProListQueryOptions(proId, search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  adminProQueryOptions(input.proId),
  marketsQueryOptions(),
  suspensionsQuery(input),
  onboardingStepsQuery(input),
];

export const overviewQueries = (input: QueriesInput): Array<WarmableQuery> => [
  onboardingStepsQuery(input),
  notesQuery(input),
  aiInterviewInviteQuery(input),
  certificatesQuery(),
  skillsQuery(),
  ...proProfileQueries({ proId: input.proId, isAdmin: true }),
];

export const blocksQueries = (input: QueriesInput): Array<WarmableQuery> => [
  adminProQueryOptions(input.proId),
  blocksQuery(input),
];

export const jobApplicationsQueries = (
  input: QueriesInput & { search: AdminJobPostingsAppliedByProListParams },
): Array<WarmableQuery> => [jobApplicationsQuery(input)];

export const sickTimeQueries = (input: QueriesInput): Array<WarmableQuery> => [sickTimeQuery(input)];
